import React, { useState, useEffect, useCallback } from 'react';

export default function GoldTicker() {
  const [price, setPrice] = useState(null);
  const [change, setChange] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchPrice = useCallback(async () => {
    try {
      // CoinGecko PAX Gold tracks XAUUSD spot price ~1:1
      // Free public API, no auth, CORS enabled
      const res = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=pax-gold&vs_currencies=usd&include_24hr_change=true');
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      if (data['pax-gold']) {
        setPrice(data['pax-gold'].usd);
        setChange(data['pax-gold'].usd_24h_change);
        setError(false);
      }
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPrice();
    const id = setInterval(fetchPrice, 60000); // refresh every 60s
    return () => clearInterval(id);
  }, [fetchPrice]);

  if (loading) {
    return (
      <div className="gold-ticker">
        <span className="gold-ticker-label">XAU/USD</span>
        <span className="gold-ticker-price">...</span>
      </div>
    );
  }

  if (error || !price) {
    return null;
  }

  const isUp = change >= 0;

  return (
    <div className="gold-ticker" title="Live XAU/USD price · refreshes every 60s">
      <span className="gold-ticker-label">XAU/USD</span>
      <span className="gold-ticker-price">${price.toFixed(2)}</span>
      <span className={`gold-ticker-change ${isUp ? 'up' : 'down'}`}>
        {isUp ? '▲' : '▼'} {Math.abs(change).toFixed(2)}%
      </span>
    </div>
  );
}
